<template>
	<v-dialog v-model="dialogMateria" max-width="800px" persistent>
		<v-card>
			<v-card-title>
				<span class="headline">{{ formTitle }}</span>
			</v-card-title>

			<v-card-text>
				<v-form ref="form">
					<v-container>
						<v-row>
							<v-col cols="12">
								<v-text-field
									v-model="editedItem.nome"
									label="Nome"
									:rules="[rules.required, rules.min2]"
								></v-text-field>
							</v-col>
              <v-col cols="12">
                <v-switch
                  v-model="editedItem.mostrar"
                  color="indigo"
                  label="Mostrar ao aluno"
                ></v-switch>
              </v-col>
						</v-row>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="error" icon @click="close()" title="Fechar formulário">
					<v-icon>fal fa-times</v-icon>
				</v-btn>
				<v-btn
					v-if="typeForm === 1"
					color="warning"
					icon
					@click="archiveChoice()"
					title="Arquivar formulário"
				>
					<v-icon>fal fa-archive</v-icon>
				</v-btn>
				<v-btn color="success" icon @click="save()" title="Salvar formulário">
					<v-icon>fal fa-save</v-icon>
				</v-btn>
			</v-card-actions>
			<OpenChoice :choice="choice" @choiceResult="choiceResult" />
		</v-card>
	</v-dialog>
</template>

<script>
import { mapState } from 'vuex'

import OpenChoice from '@/components/OpenChoice'

export default {
	inheritAttrs: false,
	components: {
		OpenChoice,
	},
	props: {
		materia: {
			default: null,
		},
		typeForm: {
			default: 0,
		},
		cursoId: null
	},

	data() {
		return {
			server: 'materia',
			editedItem: {
				id: 0,
				nome: '',
				mostrar: 1,
			},
			choice: {
				title: 'Você tem certeza?',
				dialog: false,
			},
		}
	},
	computed: {
		...mapState(['user', 'rules', 'dialogMateria']),
		formTitle() {
			return this.typeForm === 0 ? 'Cadastrar' : 'Editar'
		},
	},
	created() {
		if (this.typeForm === 1) {
			this.editedItem = Object.assign({}, this.materia)
			this.editedItem.mostrar=(this.editedItem.mostrar==1)? true:false
		}
	},

	methods: {
		close() {
			this.$store.dispatch('dialogMateria', { value: false })
			setTimeout(() => {
				this.$emit('changeTypeForm', { typeForm: 0, hideForm: 'materia' })
			}, 300)
		},
		archiveChoice() {
			this.choice.dialog = true
		},
		choiceResult(value) {
			if (value === true) {
				this.archive()
			} else {
				this.$store.dispatch('alert', {
					alertMessage: 'Not archived',
					alertType: 1,
				})
			}
		},
		archive() {
			let archive = (this.editedItem.archive==0)?1:0
			let formData = new FormData()
			formData.append('menu', this.server)
			formData.append('function', 'archive_' + this.server)
			formData.append('user_id', this.user.id)
			formData.append('id', this.editedItem.id)
			formData.append('archive', archive)
			let vd = this
			this.$axiosPost
				.post('functions.php', formData, {
					headers: { Authorization: this.user.token },
				})
				.then(function(response) {
					if (response.data.error === 0) {
						vd.$store.dispatch('alert', {
							alertMessage: response.data.alertMessage,
							alertType: 0,
            })
            vd.$store.dispatch('searchAula', { value: true })
						vd.close()
					} else {
						vd.$store.dispatch('errorServer', {
							data: response.data,
							destination: vd.$route.path,
						})
					}
				})
				.catch(function(response) {
					console.log('ERROR!! ' + response)
				})
		},

		save() {
			if (this.$refs.form.validate()) {
				if (this.typeForm === 0) {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'insert_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('curso_id', this.cursoId)
					formData.append('nome', this.editedItem.nome)
					formData.append('mostrar', this.editedItem.mostrar)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchAula', { value: true })
								vd.close()
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				} else {
					let formData = new FormData()
					formData.append('menu', this.server)
					formData.append('function', 'update_' + this.server)
					formData.append('user_id', this.user.id)
					formData.append('id', this.editedItem.id)
					formData.append('nome', this.editedItem.nome)
					formData.append('mostrar', this.editedItem.mostrar)
					let vd = this
					this.$axiosPost
						.post('functions.php', formData, {
							headers: { Authorization: this.user.token },
						})
						.then(function(response) {
							if (response.data.error === 0) {
								vd.close()
								vd.$store.dispatch('alert', {
									alertMessage: response.data.alertMessage,
									alertType: 0,
								})
								vd.$store.dispatch('searchAula', { value: true })
							} else {
								vd.$store.dispatch('errorServer', {
									data: response.data,
									destination: vd.$route.path,
								})
							}
						})
						.catch(function(response) {
							console.log('ERROR!! ' + response)
						})
				}
			}
		},
	},
}
</script>
